import React, { FC } from 'react';

import { Stack, useMobile } from 'Modules/ui3';

import { PageContainer } from '../../components/PageContainer';
import { SectionTitleH1 } from '../../components/Titles';
import { useEmissions } from '../../state/emission';
import { Emissions } from '../../components/Emissions';
import { GeneralDocuments } from '../../components/GeneralDocuments';


export const Information: FC = () => {
    const isMobile = useMobile();

    const { data: emissions, isLoading: emissionsLoading } = useEmissions();

    return (
        <PageContainer withMainButton>
            {!isMobile && (
                <SectionTitleH1 mt={0} mb={8}>
                    Раскрытие информации
                </SectionTitleH1>
            )}
            <Stack spacing={isMobile ? 2 : 4}>
                <GeneralDocuments />
                <Emissions data={emissions || []} showLoader={emissionsLoading} />
            </Stack>
        </PageContainer>
    );
};
